// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1cGHP","title":"AfterFrontImage_title__ypSRf"};